import { useEffect } from "react";
import { Button, TextField } from "@mui/material"
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import { addDepotFormValidationSchema } from "src/helpers/yup_schema";
import { addNewDepot, editDepot, getAllDepots } from "src/thunks/depotUsers";
import toastMessages from "src/constant/toastMessages.json";
import { GetError, getFloatValue } from "src/constant";
import { getAllNofificationForDashboard } from "src/thunks/dashboard";


export const AddNewDepot = ({ indData, editTextShownFlag, handleCancelButtonClick, setOpen, selectedRow, setEditTextShownFlag, handleViewRecordButtonClick }) => {
    /** redux store useDispatch & useSelector ------------------------------ **/
    const dispatch = useDispatch()
    const { addNewDepotLoading } = useSelector((state) => state.depotUsers);

    /** react hook form declaration ------------------------------ **/
    const {
        register,
        handleSubmit,
        watch,
        formState: { errors },
        reset,
    } = useForm({
        resolver: yupResolver(addDepotFormValidationSchema),
    });

    /** variable declarations ----------------------------------------------------- **/
    const intSpaceFieldValue = parseFloat(watch("intSpace", ""));
    const extSpaceFieldValue = parseFloat(watch("extSpace", ""));

    /** hooks useEffect----------------------------------------------------- **/

    /** useEffect is used to reset data in the form ------------------------- **/
    useEffect(() => {
        reset({
            depotName: indData?.name || "",
            depotCode: indData?.code || "",
            street: indData?.address?.street1 || "",
            town: indData?.address?.city || "",
            country: indData?.address?.country || "",
            postcode: indData?.address?.zip || "",
            intSpace: indData?.internalArea || "",
            extSpace: indData?.externalArea || "",
        });
    }, [])

    /**  Function for adding a new depot or editing an existing depot. -------------------- **/
    const onAddDeptFormSubmitHandler = async (data) => {
        let updatedModel = {
            name: data.depotName,
            code: data.depotCode,
            address: {
                street1: data.street,
                city: data.town,
                country: data.country,
                zip: data.postcode,
                state: "",
            },
            internalArea: data.intSpace,
            externalArea: data.extSpace,
        };

        const updatedDepotUsersArray = indData.depotUsers && indData.depotUsers[0] && indData.depotUsers.map((item, index) => {
            return {
                userId: item.userId,
            };
        });

        try {
            let result = await dispatch(
                selectedRow?.id ?
                    editDepot({ data: { ...updatedModel, id: selectedRow.id, depotUsers: updatedDepotUsersArray ? updatedDepotUsersArray : [], "isParentResourceUpdated": true } }) :
                    addNewDepot(updatedModel)
            ).unwrap();
            if (result) {
                setTimeout(() => {
                    dispatch(getAllNofificationForDashboard(1, 20));
                }, 2000);

                toast.success(selectedRow?.id ? toastMessages.depotEdited : toastMessages.depotAdded);
                handleCancelButtonClick();
                setEditTextShownFlag(false);
                dispatch(getAllDepots())
                if (selectedRow?.id)
                    handleViewRecordButtonClick();
            }
            setOpen(false);
        } catch (err) {
            toast.error(GetError(err?.response?.data?.errors) || "something issue");
        }
    };

    return <div className="add-depot-form-style">
        {!editTextShownFlag ? (
            <div className="depot-form-header-style">ADD NEW DEPOT</div>
        ) : (
            <div className="depot-form-header-style">EDIT DEPOT</div>
        )}
        <div style={{ marginTop: 40 }}>
            <form
                className="add-depot-form-mainclass"
                style={{ paddingLeft: 100, paddingRight: 100 }}
                onSubmit={handleSubmit(onAddDeptFormSubmitHandler)}
            >
                <div className="row">
                    <div className="col-md-8">
                        <TextField
                            className="depot-form-textfields-style"
                            {...register("depotName")}
                            id="standard-basic"
                            label="DEPOT NAME"
                            variant="standard"
                        />
                        <div className="error-field-class">
                            {errors.depotName?.message && errors.depotName?.message}
                        </div>
                    </div>

                    <div className="col-md-4">
                        <TextField
                            className="depot-form-textfields-style"
                            {...register("depotCode")}
                            id="standard-basic"
                            label="3 LETTER DEPOT CODE"
                            variant="standard"
                        />
                        <div className="error-field-class">
                            {errors.depotCode?.message && errors.depotCode?.message}
                        </div>
                    </div>
                </div>
                <span className="section-name-form-style">ADDRESS</span>
                <div className="row m-0">
                    <TextField
                        className="depot-form-textfields-style"
                        {...register("street")}
                        id="standard-basic"
                        label="STREET"
                        variant="standard"
                    />
                    <div className="error-field-class depotform-street-class">
                        {errors.street?.message && errors.street?.message}
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-4">
                        <TextField
                            className="depot-form-textfields-style"
                            {...register("town")}
                            id="standard-basic"
                            label="TOWN"
                            variant="standard"
                        />
                        <div className="error-field-class">
                            {errors.town?.message && errors.town?.message}
                        </div>
                    </div>

                    <div className="col-md-4">
                        <TextField
                            className="depot-form-textfields-style"
                            {...register("country")}
                            id="standard-basic"
                            label="COUNTRY"
                            variant="standard"
                        />
                        <div className="error-field-class">
                            {errors.country?.message && errors.country?.message}
                        </div>
                    </div>
                    <div className=" col-md-4">
                        <TextField
                            className="depot-form-textfields-style"
                            {...register("postcode")}
                            id="standard-basic"
                            label="POSTCODE"
                            variant="standard"
                        />
                        <div className="error-field-class">
                            {errors.postcode?.message && errors.postcode?.message}
                        </div>
                    </div>
                </div>
                <span className="section-name-form-style">STORAGE</span>
                <div className="row mb-5">
                    <div className="col-md-4">
                        <TextField
                            className="depot-form-textfields-style"
                            type="number"
                            {...register("intSpace")}
                            id="standard-basic"
                            label="INTERNAL SPACE"
                            variant="standard"
                            onInput={(e) => {
                                const parts = e.target.value.split('.');
                                if (parts.length > 1) {
                                    e.target.value = `${parts[0]}.${parts[1].slice(0, 2)}`;
                                }
                            }}
                            inputProps={{
                                step: 0.01,
                            }}
                        />
                        <div className="error-field-class">
                            {errors.intSpace?.message && errors.intSpace?.message}
                        </div>
                    </div>

                    <div className="form-floating col-md-4">
                        <TextField
                            className="depot-form-textfields-style"
                            type="number"
                            {...register("extSpace")}
                            id="standard-basic"
                            label="EXTERNAL SPACE"
                            variant="standard"
                            inputProps={{
                                step: 0.01,
                            }}
                            onInput={(e) => {
                                const parts = e.target.value.split('.');
                                if (parts.length > 1) {
                                    e.target.value = `${parts[0]}.${parts[1].slice(0, 2)}`;
                                }
                            }}
                        />
                        <div className="error-field-class">
                            {errors.extSpace?.message && errors.extSpace?.message}
                        </div>
                    </div>

                    <div className="col-md-4">
                        <TextField
                            className="depot-form-textfields-style"
                            variant="standard"
                            id="standard-read-only-input"
                            label="TOTAL SPACE"
                            value={
                                getFloatValue((intSpaceFieldValue || 0) + (extSpaceFieldValue || 0))
                            }
                            InputProps={{
                                readOnly: true,
                                disableUnderline: true,
                            }}
                        />
                    </div>
                </div>
                <div
                    className="d-flex flex-row justify-content-between"
                    style={{ marginTop: 91, marginBottom: 20 }}
                >
                    <Button
                        variant="outlined"
                        className="btn-bootstrap-submit-style"
                        style={{ color: "red", borderColor: "red" }}
                        startIcon={<CancelIcon />}
                        onClick={() => handleCancelButtonClick()}
                    >
                        Cancel
                    </Button>
                    {Object.keys(indData).length <= 0 ? (
                        <Button
                            variant="outlined"
                            disabled={addNewDepotLoading ? true : false}
                            className={`btn-bootstrap-submit-style ${addNewDepotLoading ? "fade-out" : ""}`}
                            startIcon={<CheckCircleIcon />}
                            type="submit"
                        >
                            Submit
                        </Button>
                    ) : (
                        <Button
                            variant="outlined"
                            className="btn-bootstrap-submit-style"
                            startIcon={<CheckCircleIcon />}
                            type="submit"
                        >
                            save
                        </Button>
                    )}
                </div>
            </form>
        </div>
    </div>
}